import {h, Component} from 'preact';

export default class BuyPropertyForm extends Component {
    state = {
        preapproved: false,
        lowRange: '',
        highRange: '',
        city: '',
        reqState: ''
    };

    componentDidMount() {
        const {preapproved, lowRange, highRange, city, state: reqState} = this.props;
console.log(this.props.propertyType)
        this.setState({preapproved, lowRange, highRange, city, reqState});
    }

    onAnswer = (field, val) => {
        this.setState({[field]: '' + val});
    };

    render() {
        const {editingRequestInfo, propertyType, buyerStage, submitting, saveProperty} = this.props;
        const {preapproved, reqState, city, lowRange, highRange} = this.state;

        return (
            <div className={`card property-form ${editingRequestInfo ? '' : 'hidden'}`}>
                <input type="hidden" name="priceRange" value={`${lowRange}-${highRange}`} />
                <div class="row account-form-rows">
                    <div class="col-md-4 form-group user-account-form-rows">
                        <label>City</label>
                        <input
                            class="form-control"
                            type="text"
                            name="city"
                            defaultValue={city}
                            maxLength={100}
                            onChange={({target: {value}}) => this.setState({city: value})}
                        />
                    </div>
                    <div class="col-md-2 form-group user-account-form-rows">
                        <label>State</label>
                        <input
                            class="form-control"
                            type="text"
                            name="state"
                            defaultValue={reqState}
                            maxLength={2}
                            onChange={({target: {value}}) => this.setState({reqState: value})}
                        />
                    </div>
                    <div class="col-md-6 form-group user-account-form-rows">
                        <label>Property Type</label>
                        <select class="form-control custom-select" name="propertyType" value={propertyType}>
                            <option value="">Please select</option>
                            <option value="Single Family">Single Family</option>
                            <option value="Condo or Townhouse">Condo or Townhouse</option>
                            <option value="Investment Property">Investment Property</option>
                        </select>
                        <i class="fa fa-angle-down"></i>
                    </div>
                </div>
                <div class="row account-form-rows">
                    <div class="col-md-4 form-group user-account-form-rows">
                        <label>Estimate Price Range</label>
                        <div>
                            <input
                                class="form-control price-range"
                                type="text"
                                name="lowRange"
                                value={lowRange}
                                onChange={({target: {value}}) => this.setState({lowRange: value})}
                            />
                            <div className="price-range-to">to</div>
                            <input
                                class="form-control price-range"
                                type="text"
                                name="highRange"
                                value={highRange}
                                onChange={({target: {value}}) => this.setState({highRange: value})}
                            />
                        </div>
                    </div>
                    <div class="col-md-4 form-group user-account-form-rows">
                        <label>Buying Process</label>
                        <select class="form-control custom-select required" name="buyerStage" value={buyerStage}>
                            <option value="">Please select</option>
                            <option value="0">Just Started</option>
                            <option value="2">Ready to Bid</option>
                        </select>
                        <i class="fa fa-angle-down"></i>
                    </div>
                    <div class="col-md-4 form-group user-account-form-rows adminFlagCommentSection">
                        <input type="hidden" name="preapproved" value={preapproved} />
                        <label>Pre-Approved?</label>
                        <div className="question-answer-container">
                            <div
                                className={`answer-button yes${'' + preapproved === 'true' ? ' active' : ''}`}
                                onClick={() => this.onAnswer('preapproved', true)}>
                                Yes
                            </div>
                            <div
                                className={`answer-button no${'' + preapproved === 'false' ? ' active' : ''}`}
                                onClick={() => this.onAnswer('preapproved', false)}>
                                No
                            </div>
                        </div>
                    </div>
                </div>
                <div className="actions-container row">
                    <div className={`btn orange rounded ${submitting ? 'saving' : ''}`} onClick={saveProperty}>
                        Save Changes
                    </div>
                </div>
            </div>
        );
    }
}
